import React, { useContext } from 'react'
import { Row, Col } from 'react-bootstrap'
import { MigrantContext } from '../../../contexts/migrantContext'
import { AuthContext, UserType } from '../../../contexts/authContext'
import ProfileHeader from '../../common/sections/profileHeader'
import Layout from '../../common/layout/layout'

function Profile() {
  const migrantContext = useContext(MigrantContext)
  const authContext = useContext(AuthContext)

  return (
    <Layout>
      <Row>
        <Col xl={8} className="mx-auto">
          <Row>
            <Col xs={12}>
              <ProfileHeader userType={UserType.migrant} />
            </Col>
          </Row>
          <Row xl={8} className="simpleList">
            <Col xs={12}>
              Phone number
              <br />
              <span className="gray-text">
                {migrantContext?.profile?.phonenumber || 'None'}
              </span>
            </Col>
            <Col xs={12}>
              Email Address
              <br />
              <span className="gray-text">
                {migrantContext?.profile?.email}
              </span>
            </Col>
            {authContext?.user?.providerData[0]?.providerId === 'password' && (
              <Col xs={12} data-test-id="password-field">
                Password
                <br />
                <span className="gray-text">******</span>
              </Col>
            )}
          </Row>
        </Col>
      </Row>
    </Layout>
  )
}

export default Profile
